import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-full-layout",
  templateUrl: "./full-layout.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FullLayoutComponent {
  constructor() {}
}
